export var UPDATE_FORM = "Formulario actualizado";
var FormUpdate = /** @class */ (function () {
    function FormUpdate(payload, title) {
        this.payload = payload;
        this.title = title;
        this.type = UPDATE_FORM;
    }
    return FormUpdate;
}());
export { FormUpdate };
